import { SearchResult } from "./search-result";
import { Range } from "views/components/date-range";
import { ImportStatuses } from "./monitor-application-imports";
import { AtsOrganization } from "./ats-organization";
import { AtsApplicationSource } from "./ats-application-source";

export class AtsInterviewPortalImportHistory {
    Id: string;
    InterviewPortalId: string;
    CasId: string;
    FilePath: string;
    FileVersion: string;
    FileDateUtc: string;
    FileGeneratedUtc: string;
    OrganizationName: string;
    Status: InterviewPortalImportHistoryStatus;
    StatusMessage: string;
    ApplicationSources: ApplicationSourceInfo[];
    MetaData: InterviewPortalImportHistoryMetaData;
}

export class ApplicationSourceInfo {
    ApplicationSourceId: string;
    ApplicationSourceHistoryId: string;
    ApplicationSourceHistoryStatus: ImportStatuses;
    ApplicationId: string;
    FileName: string;
    FileDateUtc: string;
    Status: InterviewPortalImportHistoryStatus;
    StatusMessage: string;
    DateUpdatedUtc: string;
}

export enum InterviewPortalImportHistoryStatus {
    Processing = 0,
    Success = 1,
    PartialSuccess = 2,
    Failed = 3,
    Superseded = 4,
    Skip = 5
}

export class InterviewPortalImportHistoryMetaData {
    OrganizationId: string;
    SeasonId: string;
    DateCreatedUtc: string;
    DateUpdatedUtc: string;
    Duration: number;
}

// Client models
export class AtsInterviewPortalImportsSearchResult extends SearchResult<AtsInterviewPortalImportHistory> {}

export type AtsInterviewPortalImportsFilter = {
    organization?: AtsOrganization;
    source?: AtsApplicationSource;
    status?: InterviewPortalImportHistoryStatus;
    range?: Range;
};
